export default __webpack_public_path__ + "static/media/banners_gift.55b68604.png";